import type { TableProps } from "antd";
import { freeze } from "immer";

export const HEADER_HEIGHT = 64;

export const tableSticky = freeze({ offsetHeader: HEADER_HEIGHT } as const, true);
export const tableScroll = freeze({ x: "max-content" } as const, true);
export const tableSortDirections = freeze<TableProps["sortDirections"]>(["ascend", "descend", "ascend"], true);
